import { render, staticRenderFns } from "./SummaryTreatmentDetails.vue?vue&type=template&id=6a8f00a0&scoped=true"
import script from "./SummaryTreatmentDetails.vue?vue&type=script&lang=js"
export * from "./SummaryTreatmentDetails.vue?vue&type=script&lang=js"
import style0 from "./SummaryTreatmentDetails.vue?vue&type=style&index=0&id=6a8f00a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f00a0",
  null
  
)

export default component.exports